<template lang="pug">
    #lista-pssc
        BaseHeader(
            :titulo="$t('mensagens.pssc.telaLista.titulo')",
            :btnTexto="$t('mensagens.pssc.telaLista.botaoCadastro')",
            :exibeBotao='!mostrar_lista_vazia'
            @btnHeaderClicado="incluirTerritorio"
        )
            div(v-if="!mostrar_lista_vazia" slot="direita" style="display:flex; align-items:center; justify-content: flex-end; gap:10px; width: 450px")
                div {{ $t('mensagens.pssc.telaLista.selectLote') }}
                el-select(
                    v-model='payload.filtros.payload.lotes',
                    filterable, multiple, value-key='id',
                    popper-class="custom-header"
                    :placeholder="$t('mensagens.pssc.telaLista.filtros.labelLotes')"
                    @change="fetchLista(0, true); fetchTotalizador()"
                    collapse-tags
                    style="min-width: 250px"
                )
                    template(id='header')
                        el-checkbox(
                            v-model="selecionar_todas_carteiras"
                            :indeterminate="selecionar_todas_carteiras_indeterminado"
                            @change="selecionarTodasCarteiras"
                        )
                            | Selecionar tudo
                    el-option(
                        v-for='(lote, index) in lotes',
                        :key='index',
                        :label='lote.nome',
                        :value='lote.id'
                        style="max-width: 250px"
                    ) {{ lote.nome }}

        .view-container-base-header
            section.lista-pssc__lista-vazia(v-if="mostrar_lista_vazia")
                div.lista-pssc__lista-vazia__content
                    img(src="@/assets/lyra-icons/pssc/gestao-lotes-lista-vazia.svg", height="121px", width="200px")
                    div.lista-pssc__lista-vazia__content__titulo
                        | {{ $t('mensagens.pssc.telaLista.listaVazia.titulo') }}
                    div.lista-pssc__lista-vazia__content__subtitulo
                        | {{ $t('mensagens.pssc.telaLista.listaVazia.subtitulo') }}
                    el-button(type='primary', @click='incluirTerritorio')
                        | {{ $t('mensagens.pssc.telaLista.listaVazia.botaoIncluirTerritorio') }}

            section.gestao-lote__container(v-else)
                section.lista-pssc__barra-pesquisa-filtro
                    .pesquisa-inteligente__content
                        .lista-pssc__barra-pesquisa-filtro__barra
                            i.el-icon-search
                            input.lista-pssc__barra-pesquisa__input(
                                v-model='payload.filtros.payload.texto',
                                type='text',
                                :placeholder="$t('mensagens.pssc.pesquisaInteligente.pesquisaInteligentePlaceholder')",
                                autocomplete='off',
                                @keyup.enter='fetchLista(0, true); fetchTotalizador()',
                                @input='habilitaPesquisa = payload.filtros.payload.texto.length >= 3'
                            )
                            el-button.primary-button.button-search.btn-filtro(
                                icon='el-icon-search',
                                type='primary',
                                size='large',
                                @click='fetchLista(0, true)',
                            ) {{ $t('mensagens.pssc.pesquisaInteligente.botaoBuscar') }}
                        transition(name='el-zoom-in-top')
                            ul.pesquisa-inteligente__ul(
                                v-show='mostrarLista',
                                v-loading='loadingPesquisaInteligente'
                            )
                                .mb-2.pesquisa-inteligente__lista-vazia(
                                    v-if='sugestoesBusca.length === 0'
                                ) {{ $t('mensagens.pssc.pesquisaInteligente.nenhumResultadoEncontrado') }}
                                .pesquisa-inteligente__lista(v-else)
                                    .mb-2.pesquisa-inteligente__car(v-for='opcao in sugestoesBusca')
                                        .pesquisa-inteligente__categoria
                                            span(
                                                v-if='opcao.resultados.length'
                                            ) {{ internacionalizacaoCategoria(opcao.categoria) }}

                                        li.pesquisa-inteligente__item(
                                            v-for='resultado in opcao.resultados',
                                            @click='selecionarOpcao(resultado.codigo || resultado.nome)'
                                        )
                                            span() {{ resultado.codigo || resultado.nome }}

                    .lista-pssc__barra-pesquisa-filtro__filtro
                        el-popover(placement='bottom', width='591', trigger='click')
                            el-button.button-outline.btn-filtro(
                                icon='lyra-icon lyra-filtro',
                                name='filtro',
                                slot='reference'
                            ) {{ $t('mensagens.pssc.telaLista.botaoFiltro') }}

                            div.mb-2(style="display: flex; justify-content: space-between; align-items: center")
                                #titulo-filtro
                                    | {{ $t('mensagens.pssc.telaLista.botaoFiltro') }}
                                #titulo-filtro-link(@click='fetchLista(0, true); fetchTotalizador()')
                                    | {{ $t('mensagens.pssc.telaLista.botaoAplicarFiltro') }}

                            el-collapse.lista-pssc__barra-pesquisa-filtro__filtro-popover-collapse(
                                v-model='payload.filtros.collapseAtivo',
                                accordion,
                                @change='abrirCollapse'
                            )
                                el-collapse-item(
                                    :title='$t("mensagens.pssc.telaLista.filtros.localidade")',
                                    name='estados'
                                )
                                    section(style="display: flex; justify-content: flex-start")
                                        div.mr-3(v-loading='!estados.length')
                                            el-select(
                                                v-model='payload.filtros.payload.estado',
                                                filterable,
                                                clearable,
                                                value-key='id',
                                                @change="buscarMunicipios(); payload.filtros.payload.municipio = null"
                                                :placeholder='$t("mensagens.blocoFiltros.uteis.uf")'
                                            )
                                                el-option(
                                                    v-for='(estado, index) in estados',
                                                    :key='index',
                                                    :label='estado.nome',
                                                    :value='estado.id'
                                                ) {{ estado.nome }}
                                        div
                                            el-select(
                                                v-model='payload.filtros.payload.municipio',
                                                filterable,
                                                clearable,
                                                value-key='id',
                                                :placeholder='$t("mensagens.blocoFiltros.uteis.municipio")',
                                                :disabled='!payload.filtros.payload.estado'
                                            )
                                                el-option(
                                                    v-for='(municipio, index) in municipios',
                                                    :key='index',
                                                    :label='municipio.nome',
                                                    :value='municipio.id'
                                                ) {{ municipio.nome }}
                                el-collapse-item(
                                    :title='$t("mensagens.pssc.telaLista.filtros.analise")',
                                    name='statusAnalise'
                                )
                                    el-checkbox-group(
                                        v-model='payload.filtros.payload.statusAnalise',
                                        :max='3'
                                    )
                                        el-checkbox.area__checkbox__filtro__dashboard(label='SEM_PENDENCIA')
                                            | {{ $t('mensagens.pssc.telaLista.filtros.analiseSemPendencia') }}
                                        el-checkbox.area__checkbox__filtro__dashboard(label='COM_PENDENCIA')
                                            | {{ $t('mensagens.pssc.telaLista.filtros.analiseComPendencia') }}
                                        el-checkbox.area__checkbox__filtro__dashboard(label='INCONFORME')
                                            | {{ $t('mensagens.pssc.telaLista.filtros.analiseInconforme') }}
                                el-collapse-item(
                                    :title='$t("mensagens.pssc.telaLista.filtros.statusEnvioTrilha")',
                                    name='statusEnvioTrilha'
                                )
                                    el-checkbox-group(v-model='payload.filtros.payload.statusEnvioTrilha')
                                        el-checkbox.area__checkbox__filtro__dashboard(label='GERANDO_TRILHA')
                                            | {{ $t('mensagens.pssc.telaLista.filtros.statusEnvioTrilhaGerandoTrilha') }}
                                        el-checkbox.area__checkbox__filtro__dashboard(label='AGUARDANDO_ENVIO')
                                            | {{ $t('mensagens.pssc.telaLista.filtros.statusAguardandoEnvio') }}
                                        el-checkbox.area__checkbox__filtro__dashboard(label='NA_FILA_ENVIO')
                                            | {{ $t('mensagens.pssc.telaLista.filtros.statusEnvioTrilhaNaFila') }}
                                        el-checkbox.area__checkbox__filtro__dashboard(label='ENVIADO')
                                            | {{ $t('mensagens.pssc.telaLista.filtros.statusEnvioTrilhaEnviado') }}
                                        el-checkbox.area__checkbox__filtro__dashboard(label='ERRO_CONTATO')
                                            | {{ $t('mensagens.pssc.telaLista.filtros.statusEnvioTrilhaErroContato') }}
                                        el-checkbox.area__checkbox__filtro__dashboard(label='ERRO_ENVIO')
                                            | {{ $t('mensagens.pssc.telaLista.filtros.statusEnvioTrilhaErroEnvio') }}
                                        el-checkbox.area__checkbox__filtro__dashboard(label='VISUALIZADO')
                                            | {{ $t('mensagens.pssc.telaLista.filtros.statusVisualizado') }}
                                        el-checkbox.area__checkbox__filtro__dashboard(label='SEM_TRILHA')
                                            | {{ $t('mensagens.pssc.telaLista.filtros.statusSemTrilha') }}

                section.lista-pssc__totalizadores
                    #titulo {{ $t('mensagens.pssc.telaLista.tituloTotalizadores') }}

                    .lista-pssc__totalizadores__cards
                        .lista-pssc__totalizadores__cards__card(v-loading="conditions.onFetching")
                            div(style='display: flex; align-items: center; width: 100%')
                                img(src="@/assets/lyra-icons/pssc/totalizador-imoveis.svg").mr-2
                                | {{ $t('mensagens.pssc.telaLista.cardTotalTerritorios') }}
                            el-statistic(:value="payload.totalizadores.totalTerritorios")

                        .lista-pssc__totalizadores__cards__card(v-loading="conditions.onFetching")
                            div(style='display: flex; align-items: center; width: 100%')
                                img(src="@/assets/lyra-icons/pssc/totalizador-conforme.svg").mr-2
                                | {{ $t('mensagens.pssc.telaLista.cardSemPendencia') }}
                            el-statistic(:value="payload.totalizadores.semPendencia")

                        .lista-pssc__totalizadores__cards__card(v-loading="conditions.onFetching")
                            div(style='display: flex; align-items: center; width: 100%')
                                img(src="@/assets/lyra-icons/pssc/totalizador-inconforme-dashboard.svg").mr-2
                                | {{ $t('mensagens.pssc.telaLista.cardComPendencia') }}
                            el-statistic(:value="payload.totalizadores.comPendencia")

                        .lista-pssc__totalizadores__cards__card(v-loading="conditions.onFetching")
                            div(style='display: flex; align-items: center; width: 100%')
                                img(src="@/assets/lyra-icons/pssc/totalizador-inconforme.svg").mr-2
                                | {{ $t('mensagens.pssc.telaLista.cardInconforme') }}
                            el-statistic(:value="payload.totalizadores.inconforme")

                section.lista-pssc__lista
                    #titulo
                        span(style='padding: 8px 0') {{ $t('mensagens.pssc.telaLista.tituloLista') }}
                        div(style='display: flex')
                            el-button.primary-button.button-search.btn-reprocessar(
                                v-if='payload.totalErroProcessamento >= 1',
                                icon='el-icon-refresh-right',
                                type='primary',
                                size='small',
                                @click='reprocessarTerritoriosComErro()',
                                :disabled='(this.statusReprocessamento)'
                            ) {{ this.statusProcessamento() }}

                            el-button.primary-button.button-search.btn-enviar-trilha(
                                icon='el-icon-position',
                                type='primary',
                                size='small',
                                @click='dispararTrilha',
                                :disabled='!(this.qtdSelecionados >= 1)'
                            ) {{ $t('mensagens.pssc.telaLista.tabela.botaoEnviarTrilha') }}

                    div.selecao-tabela__container
                        div.card-contagem-selecao(
                            v-if='qtdSelecionados>0'
                        )
                            div.contagem-selecao
                                span.contador-selecao {{this.qtdSelecionados}}
                                    span.descricao-selecao {{this.descricaoSelecionados()}}
                            div.acao-selecao(
                                @click='selecionarRemanescentes()'
                            ) {{ this.totalRemanescente }}

                    .lista-pssc__lista__tabela
                        el-table(
                            :data='payload.itens',
                            stripe,
                            height='calc(100% - 40px)',
                            @select='alterarSelecao'
                            @selection-change='mudarSelecao'
                            @select-all='selecionarTodos',
                            ref='tabelaGestaoLotesPssc',
                            :stripe='false'
                            :rowClassName='rowClassName'
                            v-loading='conditions.onFetching',
                            :empty-text="$t('mensagens.pssc.telaLista.tabela.listaVazia')"
                        )
                            el-table-column(
                                align='left',
                                type="selection",
                                :selectable='(row) => { return row.enviar_trilha; }',
                                width='42px',
                                class-name='el-checkbox__table__gestao-lote'
                            )

                            el-table-column(
                                :label='$t("mensagens.pssc.telaLista.tabela.labels.territorio")',
                                align='left',
                                min-width='150px'
                            )
                                template(slot-scope='scope')
                                    span(style="line-height: 15px; word-break: keep-all !important")
                                        | {{ scope.row.territorio }}

                            el-table-column(
                                :label='$t("mensagens.pssc.telaLista.tabela.labels.areaHa")',
                                align='left',
                                width='110px'
                            )
                                template(slot-scope='scope')
                                    span {{ scope.row.areaHa }}

                            el-table-column(
                                :label='$t("mensagens.pssc.telaLista.tabela.labels.pessoa")',
                                align='left'
                            )
                                template(slot-scope='scope')
                                    div(style="display: grid; grid-template-columns: 1fr 0.1fr")
                                        div(style="margin-right: 10px")
                                            div(style="line-height: 15px; word-break: keep-all !important") {{ scope.row.pessoas[0].nome }}
                                        el-tooltip(v-if="scope.row.pessoas.length > 1", placement='bottom', effect="light")
                                            el-tag(color="#359138", effect="dark", type="primary", size="small",
                                                style="border: none; padding-top: 2px")
                                                | + {{ scope.row.pessoas.length - 1 }}
                                            div.lista-scroll(slot="content")
                                                div(v-for="(item, index) in scope.row.pessoas" :key="index")
                                                    p(v-if="index !== 0" ) {{ item.nome + ' (' + formatCpfCnpj(item.documento) + ')' }}
                                    div
                                        div(style="font-size: 13px; color: #7C7C7C") {{ formatCpfCnpj(scope.row.pessoas[0].documento) }}

                            el-table-column(
                                :label='$t("mensagens.pssc.telaLista.tabela.labels.localidade")',
                                align='left'
                            )
                                template(slot-scope='scope')
                                    div(style="word-break: keep-all !important") {{ scope.row.localidade.cidade }}
                                    div(style="font-size: 13px; color: #7C7C7C") {{ scope.row.localidade.estado }}

                            el-table-column(
                                :label='$t("mensagens.pssc.telaLista.tabela.labels.analise")',
                                align='center',
                                width='220'
                            )
                                template(slot-scope='scope')
                                    el-tooltip.status-analise__tooltip(
                                        placement='top',
                                        effect='light'
                                    )
                                        template(#content)
                                            div(style='white-space: pre-line; text-align: left;')
                                                p(style='margin-bottom: 5px; font-size: 13px; font-weight: 500') {{ $t('mensagens.pssc.telaLista.tabela.tooltipStatus.etapasDoProcessamento') }}
                                                div(
                                                    v-for='status in scope.row.statusGerais',
                                                    style='display: flex; padding: 1px 0;'
                                                )
                                                    i(:class='getIconeStatusProcessamento(status.nivelAlerta)')
                                                    span.etapa-processamento-label {{ $t(`mensagens.pssc.telaLista.tabela.tooltipStatus.${status.codigo}`) }}
                                        el-tag(
                                            size="small", effect="plain",
                                            :style="identificarStyleTag(scope.row.status_analise)"
                                        ) {{ $t(`mensagens.pssc.telaLista.tabela.enumsSituacoes.${scope.row.status_analise}`) }}

                            el-table-column(
                                :label='$t("mensagens.pssc.telaLista.tabela.labels.status_trilha")',
                                align='center'
                            )
                                template(slot-scope='scope')
                                    el-tag(
                                        size="small", effect="plain",
                                        :style="identificarStyleTag(scope.row.status_trilha)"
                                    ) {{ $t(`mensagens.pssc.telaLista.tabela.enumsSituacoes.${scope.row.status_trilha}`) }}

                            el-table-column(
                                :label='$t("mensagens.pssc.telaLista.tabela.labels.acoes")',
                                align='center',
                                width='100'
                            )
                                template(slot-scope='scope')
                                    el-dropdown.action-button(trigger='click')
                                        span.el-dropdown-link
                                            i.mdi.mdi-dots-vertical.mudando-cursor
                                        el-dropdown-menu(slot='dropdown')
                                            el-dropdown-item(
                                                v-for='(acao, index) in scope.row.acoes_disponiveis',
                                                :key='index',
                                                :icon='acoes_disponiveis[acao].icone',
                                                @click.native='acoes_disponiveis[acao].callback(scope.row)'
                                            ) {{ $t(`mensagens.pssc.telaLista.tabela.acoes.${acoes_disponiveis[acao].codigo}`) }}

                        .lista-pssc__lista__tabela__rodape
                            div(style="display: flex; align-items: center; justify-content: space-between")
                                div.mr-4 {{ payload.paginacao.total }} {{ $t(`mensagens.pssc.telaLista.tabela.paginacaoResultado`) }}

                                | {{ $t(`mensagens.pssc.telaLista.tabela.paginacaoPorPagina`) }}
                                el-select(
                                    v-model='payload.paginacao.itensPorPagina',
                                    class="ml-2",
                                    style='width: 70px',
                                    size="mini"
                                    @change="mudarTamanhoTabela()"
                                )
                                    el-option(
                                        v-for='item in itensPorPagina',
                                        :key='item',
                                        :label='item',
                                        :value='item'
                                    )

                            .tabela-rodape--pagination
                                el-pagination(
                                    mini,
                                    layout='prev, pager, next, jumper',
                                    hide-on-single-page
                                    :page-size='payload.paginacao.itensPorPagina',
                                    :current-page.sync='payload.paginacao.pagina',
                                    :total='payload.paginacao.total',
                                    @current-change='proximaPagina'
                                )

                ModalEditarDadosContato(
                    :show='modalEditarDadosContato.mostrar',
                    :territorio='modalEditarDadosContato.territorio'
                    @closeDialog='modalEditarDadosContato.mostrar = false'
                )
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import ModalEditarDadosContato from '@/components/pssc/ModalEditarDadosContatoPssc';
import PSSCService from '@/services/PSSCService';
import {identificarStyleTag} from '@/constants/ColorsUtilsPssc';
import formatters from '@/utils/formatters';
import { mapState } from 'vuex';

export default {
    name: 'PSSC',
    components: {BaseHeader, ModalEditarDadosContato},
    data() {
        return {
            conditions: {
                onFetching: false,
                onSaving: false
            },
            payload: {
                filtros: {
                    payload: {
                        texto: null,
                        estado: null,
                        municipio: null,
                        areaImovel: null,
                        statusAnalise: [],
                        statusEnvioTrilha: [],
                        lotes: []
                    },
                    collapseAtivo: [''],
                    situacoesCar: []
                },
                totalizadores: {
                    total_imoveis: 0,
                    inconforme: 0,
                    conforme: 0
                },
                itens: [],
                paginacao: {
                    direcao: null,
                    itensPorPagina: 10,
                    ordernarPor: null,
                    pagina: 0,
                    totalPaginas: 0,
                    total: 0
                },
                trilhasDisponiveis: 0,
                totalErroProcessamento: 0
            },
            selecionar_todas_carteiras: true,
            selecionar_todas_carteiras_indeterminado: false,
            itensPorPagina: [10, 20, 50, 100],
            qtdSelecionados: 0,
            totalRemanescente: '',
            selecionarTodosTerritorios: false,
            limparSelecao: false,
            selecaoTerritorios: [],
            linhasSelecionadas: [],
            mostrarLista: false,
            loadingPesquisaInteligente: false,
            habilitaPesquisa: false,
            sugestoesBusca: [],
            estados: [],
            municipios: [],
            lotes: [],
            mostrar_lista_vazia: true,
            reprocessarTerritorios: false,
            statusReprocessamento: false,
            intervaloProcessamento: null,
            modalEditarDadosContato: {
                mostrar: false,
                territorio: null
            },
            acoes_disponiveis: {
                VISUALIZAR_CAR: {
                    codigo: 'VISUALIZAR_CAR',
                    icone: 'el-icon-view',
                    callback: this.visualizarCar
                },
                VER_TRILHA: {
                    codigo: 'VER_TRILHA',
                    icone: 'el-icon-guide',
                    callback: this.visualizarTrilha
                },
                EDITAR_DADOS_CONTATO: {
                    codigo: 'EDITAR_DADOS_CONTATO',
                    icone: 'el-icon-edit',
                    callback: this.editarContato
                }
            },
            acaoCollapse: {
                estados: {
                    collapse: 'estados',
                    callback: 'buscarEstados'
                }
            }
        };
    },
    computed: {
        ...mapState(['usuarioLogado'])
    },
    watch: {
        'payload.filtros.payload.lotes'(val) {
            if (val.length === 0) {
                this.selecionar_todas_carteiras = false;
                this.selecionar_todas_carteiras_indeterminado = false;
            } else if (val.length === this.lotes.length) {
                this.selecionar_todas_carteiras = true;
                this.selecionar_todas_carteiras_indeterminado = false;
            } else {
                this.selecionar_todas_carteiras_indeterminado = true;
            }
        }
    },
    async mounted() {
        await this.fetchLista(0, true);
        if (this.payload.itens.length !== 0) {
            this.mostrar_lista_vazia = false;
        }
        await this.fetchLotes();
        await this.fetchTotalizador();

        const input = document.getElementsByClassName('lista-pssc__barra-pesquisa__input')[0];
        const handleInput = this.aguardarInputPesquisaInteligente(() => {
            this.pesquisaInteligente();
        }, 1000);
        input.addEventListener('input', handleInput);

        const pesquisaInteligenteContainer = document.getElementsByClassName('pesquisa-inteligente__ul')[0];
        const handleClickOutsidePesquisaInteligente = (event) => {
            if (!pesquisaInteligenteContainer.contains(event.target)) {
                this.mostrarLista = false;
                this.sugestoesBusca = [];
            }
        };
        document.addEventListener('click', handleClickOutsidePesquisaInteligente);

        this.intervaloProcessamento = setInterval(() => {
            this.checarReprocessamento();
        }, 10000);
    },
    beforeUnmount() {
        if (this.intervaloProcessamento) {
            clearInterval(this.intervaloProcessamento);
        }
    },
    methods: {
        identificarStyleTag,
        async fetchLotes() {
            try {
                const {data} = await PSSCService.buscarLotes();
                this.lotes = data.itens;
                this.payload.filtros.payload.lotes = data.itens.map(item => item.id);
            } catch {
                this.$notify.error({
                    message: 'Não foi possível buscar lotes.'
                });
            }
        },
        async fetchTotalizador() {
            try {
                const {data} = await PSSCService.buscarTotalizadores(this.payload.filtros.payload);
                this.payload.totalizadores = data;
            } catch {
                this.$notify.error({
                    message: 'Não foi possível buscar lotes.'
                });
            }
        },
        async fetchLista(pagina, lockscreen) {
            this.mostrarLista = false;
            this.conditions.onFetching = lockscreen;

            const paginacao = {...this.payload.paginacao};
            paginacao.pagina = pagina;

            await PSSCService.buscarPorFiltro({
                ...this.payload.filtros.payload,
                paginacao: paginacao
            }, lockscreen)
                .then(({data}) => {
                    this.payload.itens = data.itens;

                    this.payload.paginacao.total = data.paginacao.total;
                    this.payload.paginacao.itensPorPagina = data.paginacao.itensPorPagina;
                    this.payload.paginacao.totalPaginas = data.paginacao.totalPaginas;
                    this.payload.trilhasDisponiveis = data.trilhas_disponiveis;
                    this.payload.totalErroProcessamento = data.total_erro_processamento;
                    if (data.total_erro_processamento >= 1) {
                        this.statusReprocessamento = false;
                    }
                })
                .catch(() => {
                    this.$notify.error({
                        message: this.$t('mensagens.operacao.notificacao.erroSituacao')
                    });
                })
                .finally(() => {
                    this.conditions.onFetching = false;
                    const component = document.getElementsByClassName('el-pagination__jump')[0];
                    if (component) {
                        component.firstChild.textContent =
                            this.$t('mensagens.pssc.telaLista.tabela.irParaPagina');
                    }

                    setTimeout(() => {
                        this.payload.itens.forEach((row, index) => {
                            const checkbox = document.querySelector(
                                `.el-table__body-wrapper tbody tr:nth-child(${index + 1}) .el-checkbox__input input`
                            );
                            if (checkbox) {
                                checkbox.id = `idTerritorio-${row.id}`;
                            }
                        });
                    }, 0);
                });
        },
        async reprocessarTerritoriosComErro() {
            this.statusReprocessamento = true;
            await PSSCService.reprocessarTerritorios()
                .then(() => {
                    setTimeout(() => {
                        this.fetchLista(this.payload.paginacao.pagina - 1, false);
                        this.fetchTotalizador();
                    }, 0);
                })
                .catch(() => {
                    this.$notify.error({
                        message: this.$t('mensagens.pssc.telaLista.tabela.erroReprocessarTerritorios')
                    });
                });
        },
        checarReprocessamento() {
            let totalEmProcessamento = this.payload.itens.filter(t => t.status_analise === 'EM_PROCESSAMENTO' || t.status_trilha === 'GERANDO_TRILHA');
            if (totalEmProcessamento.length === 0) {
                this.reprocessarTerritorios = false;
            } else {
                this.reprocessarTerritorios = true;
                if (!this.conditions.onFetching) {
                    this.fetchLista(this.payload.paginacao.pagina - 1, false);
                    this.fetchTotalizador();
                }
            }
        },
        statusProcessamento() {
            let stringTerritorio = this.payload.totalErroProcessamento > 1
                ? this.$t('mensagens.pssc.telaLista.tabela.territorioPlural')
                : this.$t('mensagens.pssc.telaLista.tabela.territorioSingular');
            if (this.payload.totalErroProcessamento >= 1 && !this.statusReprocessamento) {
                return this.$t('mensagens.pssc.telaLista.tabela.reprocessarTerritorios').replace('##', this.payload.totalErroProcessamento) +
                    stringTerritorio;
            } else if (this.payload.totalErroProcessamento >= 1 && this.statusReprocessamento) {
                return this.$t('mensagens.pssc.telaLista.tabela.reprocessandoTerritorios').replace('##', this.payload.totalErroProcessamento) +
                    stringTerritorio;
            }
        },
        getIconeStatusProcessamento(nivelAlerta) {
            if (nivelAlerta === 'CINZA') {
                return 'mdi mdi-clock-outline status-processamento-cinza';
            } else if (nivelAlerta === 'VERDE') {
                return 'mdi mdi-check-circle status-processamento-verde';
            } else if (nivelAlerta === 'AMARELO') {
                return 'mdi mdi-alert-circle status-processamento-amarelo';
            } else if (nivelAlerta === 'VERMELHO') {
                return 'mdi mdi-close-circle status-processamento-vermelho';
            }
        },
        abrirCollapse(ref) {
            if (ref) {
                try {
                    if (ref !== 'estados') return;
                    const acao = this.acaoCollapse[ref];
                    if (!this[ref].length && typeof this[ref] !== 'string') {
                        this[acao.callback]();
                    }
                } catch (error) {
                    this.exibirNotify(
                        'error',
                        'Não foi possível buscar os dados.'
                    );
                    throw new Error(
                        'Ação não registrada para o collapse:' +
                        ref +
                        ', ERRRO:' +
                        error
                    );
                }
            }
        },
        proximaPagina(pagina) {
            this.fetchLista(pagina - 1, true)
                .then(() => this.marcarSelecionados());
        },
        mudarTamanhoTabela() {
            this.fetchLista(0, true)
                .then(() => this.marcarSelecionados());
        },
        async dispararTrilha() {
            await PSSCService.dispararTrilha({
                ...this.payload.filtros.payload,
                selecaoTerritorios: this.selecaoTerritorios,
                qtdSelecionados: this.qtdSelecionados,
                selecionarTodosTerritorios: this.selecionarTodosTerritorios
            })
                .then(() => {
                    this.selecionarTodosTerritorios = false;
                    this.limparSelecao = true;
                }).catch(() => {
                    this.$notify.error({
                        message: this.$t('mensagens.pssc.telaLista.tabela.erroEnviarTrilha')
                    });
                }).finally(() => {
                    this.selecaoTerritorios = [];
                    this.selecionarTodosTerritorios = false;
                    this.limparSelecao = false;
                    this.contarSelecionados();
                    this.fetchLista(0, true);
                });
        },
        descricaoSelecionados() {
            if (this.qtdSelecionados > 1) {
                return this.$t('mensagens.pssc.telaIncluirTerritorios.territoriosEstaoSelecionados');
            } else {
                return this.$t('mensagens.pssc.telaIncluirTerritorios.territorioEstaSelecionado');
            }
        },
        alterarSelecao(_, linhaClicada) {
            if (!this.selecaoTerritorios.includes(linhaClicada.id)) {
                this.selecaoTerritorios.push(linhaClicada.id);
            } else {
                let index = this.selecaoTerritorios.indexOf(linhaClicada.id);
                this.selecaoTerritorios.splice(index, 1);
            }
            this.contarSelecionados();
        },
        mudarSelecao(linhas) {
            this.linhasSelecionadas = linhas;
        },
        rowClassName({row}) {
            return this.linhasSelecionadas.includes(row) ? 'table-row_selected' : '';
        },
        selecionarTodos(selecao) {
            if (this.selecionarTodosTerritorios) {
                this.payload.itens.forEach(territorio => {
                    var index = this.selecaoTerritorios.findIndex(st => st === territorio.id);
                    if (index === -1 && territorio.enviar_trilha) {
                        this.selecaoTerritorios.push(territorio.id);
                    }
                });
            } else {
                if (this.limparSelecao) {
                    this.selecaoTerritorios = [];
                } else {
                    if (selecao.length === 0) {
                        this.payload.itens.forEach(territorio => {
                            var index = this.selecaoTerritorios.findIndex(st => st === territorio.id);
                            if (index !== -1) {
                                this.selecaoTerritorios.splice(index, 1);
                            }
                        });
                    } else {
                        selecao.forEach(territorio => {
                            var index = this.selecaoTerritorios.findIndex(st => st === territorio.id);
                            if (index === -1) {
                                this.selecaoTerritorios.push(territorio.id);
                            }
                        });
                    }
                }
            }
            this.contarSelecionados();
        },
        contarSelecionados() {
            if (!this.selecionarTodosTerritorios) {
                this.qtdSelecionados = this.selecaoTerritorios.length;
            } else {
                this.qtdSelecionados = parseInt(this.payload.trilhasDisponiveis - this.selecaoTerritorios.length);
            }
            this.atualizarRemanescentes();
            this.ajustarAlturaTabela();
        },
        atualizarRemanescentes() {
            if (
                (this.selecionarTodosTerritorios && this.selecaoTerritorios.length === 0) ||
                (!this.selecionarTodosTerritorios && this.payload.trilhasDisponiveis === this.selecaoTerritorios.length)
            ) {
                this.totalRemanescente = this.$t('mensagens.pssc.telaIncluirTerritorios.limparSelecao');
            } else {
                var total = 0;
                if (this.selecionarTodosTerritorios) {
                    total = this.selecaoTerritorios.length;
                } else {
                    total = Number.parseInt((this.payload.trilhasDisponiveis) - (this.selecaoTerritorios.length));
                }

                if (total === 1) {
                    this.totalRemanescente = this.$t('mensagens.pssc.telaIncluirTerritorios.selecionarUmTerritorioDaLista');
                } else {
                    let texto = this.$t('mensagens.pssc.telaIncluirTerritorios.selecionarDemaisTerritoriosDaLista').split('{totalRemanescente}');
                    this.totalRemanescente = texto[0] + total + texto[1];
                }
            }
        },
        selecionarRemanescentes() {
            if (this.qtdSelecionados === this.payload.trilhasDisponiveis) {
                this.limparSelecao = true;
                document.getElementsByClassName('el-checkbox__table__gestao-lote')[0].querySelector('input.el-checkbox__original').click();
            } else {
                this.limparSelecao = false;
                const checkbox = document.getElementsByClassName('el-checkbox__table__gestao-lote');
                for (let i = 1; i < checkbox.length; i++) {
                    const inputElement = checkbox[i].querySelector('input.el-checkbox__original');
                    if (inputElement && !inputElement.checked) {
                        inputElement.click();
                    }
                }
            }

            this.selecaoTerritorios = [];
            this.selecionarTodosTerritorios = !this.limparSelecao;
            this.limparSelecao = false;
            this.contarSelecionados();
        },
        marcarSelecionados() {
            if (this.payload.itens) {
                this.payload.itens.forEach(territorio => {
                    var index = this.selecaoTerritorios.findIndex(st => st === territorio.id);
                    if (this.selecionarTodosTerritorios) {
                        if (index === -1 && territorio.enviar_trilha) {
                            this.$refs.tabelaGestaoLotesPssc.toggleRowSelection(territorio);
                        }
                    } else {
                        if (index !== -1 && territorio.enviar_trilha) {
                            this.$refs.tabelaGestaoLotesPssc.toggleRowSelection(territorio);
                        }
                    }
                });
            }
        },
        ajustarAlturaTabela() {
            var elements = document.getElementsByClassName('lista-pssc__lista__tabela');
            if (parseInt(this.qtdSelecionados) >= 1) {
                elements[0].style.height = 'calc(100vh - 481px)';
            } else {
                elements[0].style.height = 'calc(100vh - 433px)';
            }
        },
        exibirNotify(tipo, message) {
            this.$notify[tipo]({
                message
            });
        },
        async buscarEstados() {
            await PSSCService.buscarLocalidadeTerritoriosElegíveis({
                'gestaoLote': true,
                'idSuperior': 1,
                'nivel': 1
            })
                .then(({data}) => {
                    setTimeout(() => {
                        this.estados = data;
                    }, 500);
                })
                .catch(error => {
                    this.exibirNotify(
                        'error',
                        'Não foi possível buscar os dados de estados.'
                    );
                    throw error;
                });
        },
        async buscarMunicipios() {
            if (this.payload.filtros.payload.estado) {
                await PSSCService.buscarLocalidadeTerritoriosElegíveis({
                    'gestaoLote': true,
                    'idSuperior': this.payload.filtros.payload.estado,
                    'nivel': 2
                })
                    .then(({data}) => {
                        this.municipios = null;
                        setTimeout(() => {
                            this.municipios = data;
                        }, 500);
                    })
                    .catch(error => {
                        this.exibirNotify(
                            'error',
                            'Não foi possível buscar os dados de municipio.'
                        );
                        throw error;
                    });
            }
        },
        selecionarTodasCarteiras(value) {
            if (value) {
                this.payload.filtros.payload.lotes = this.lotes.map(item => item.id);
                this.fetchLista(0, true);
                this.fetchTotalizador();
            } else {
                if (this.payload.filtros.payload.lotes.length !== this.lotes.length) {
                    this.fetchLista(0, true);
                    this.fetchTotalizador();
                }
                this.payload.filtros.payload.lotes = [];
            }
        },
        incluirTerritorio() {
            this.$router.push({name: 'IncluirTerritorioPSSC'});
        },
        editarContato(row) {
            this.modalEditarDadosContato.territorio = row.id;
            this.modalEditarDadosContato.mostrar = true;
        },
        visualizarTrilha(row) {
            window.open(window.location.href + '/trilha/' + row.id + '/visao-trilha/' + this.usuarioLogado.idKeyCloack, '_blank');
        },
        visualizarCar(row) {
            if (this.$route.name !== 'TerritorioPssc') {
                this.$router.push({
                    name: 'TerritorioPssc',
                    params: {
                        territorio: row.id
                    }
                });
            } else {
                this.$router.go();
            }
        },
        aguardarInputPesquisaInteligente(func, delay) {
            let temporizador;
            return function (...args) {
                clearTimeout(temporizador);
                temporizador = setTimeout(() => func.apply(this, args), delay);
            };
        },
        async pesquisaInteligente() {
            if (this.habilitaPesquisa) {
                this.loadingPesquisaInteligente = true;
                this.mostrarLista = true;
                await PSSCService.pesquisaInteligentePssc({
                    'texto': this.payload.filtros.payload.texto,
                    'gestaoLote': true
                })
                    .then(({data}) => {
                        if (data.cars.resultados.length === 0 && data.territorios.resultados.length === 0) {
                            this.sugestoesBusca = [];
                        } else {
                            this.sugestoesBusca = data;
                        }
                        this.loadingPesquisaInteligente = false;
                    })
                    .catch(error => {
                        this.exibirNotify(
                            'error',
                            'Não foi possível buscar os territórios a partir do termo informado.'
                        );
                        throw error;
                    });
            } else {
                this.mostrarLista = false;
                this.sugestoesBusca = [];
            }
        },
        selecionarOpcao(chave) {
            this.payload.filtros.payload.texto = chave;
            this.fetchLista(0, true);
        },
        internacionalizacaoCategoria(chave) {
            if (!chave) {
                return;
            }
            let chaveMaiuscula = chave.toUpperCase();
            chaveMaiuscula = chaveMaiuscula.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
            chaveMaiuscula = chaveMaiuscula.replace(/\s+/g, '-');

            return this.$t(`mensagens.pssc.pesquisaInteligente.categorias.${chaveMaiuscula}`);
        },
        formatCpfCnpj(cpfCnpj) {
            return formatters.numeralStringFormatToDocumento(formatters.removerPontuacaoDocumento(cpfCnpj));
        }
    }
};
</script>

<style lang="scss">
#lista-pssc {
    height: 100%;
    width: 100%;
    gap: 0 !important;

    .view-container-base-header {
        .gestao-lote__container {
            padding: 4px 4px 0 4px;
        }
    }

    .lista-pssc__lista-vazia {
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: white;
        border-radius: 10px;

        .lista-pssc__lista-vazia__content {
            display: grid;
            justify-items: center;
            width: 500px;
            text-align: center;

            .lista-pssc__lista-vazia__content__titulo {
                font-size: 18px;
                font-weight: 500;
                margin-bottom: 15px;
            }

            .lista-pssc__lista-vazia__content__subtitulo {
                font-size: 14px;
                margin-bottom: 15px;
            }
        }
    }

    .lista-pssc__barra-pesquisa-filtro {
        display: grid;
        gap: 14px;
        grid-template-columns: calc(100% - 185px) 169px;
        height: 46px;
        margin-bottom: 20px;

        .lista-pssc__barra-pesquisa-filtro__barra {
            height: 46px;
            border-radius: 5px;
            color: var(--primary);
            background-color: var(--white);
            display: flex;
            justify-content: center;
            box-shadow: 0 1px 5px 0 var(--block-shadow);

            i.el-icon-search {
                color: var(--primary);
                font-size: 25px;
                font-weight: bold;
                display: flex;
                align-items: center;
                margin: 0 8px;
            }

            .el-button {
                width: fit-content;
                margin-right: 0px !important;
                display: flex;
                align-items: center;
                margin: 0 8px;

                .el-icon-search {
                    color: var(--white);
                    margin: 0;
                    font-size: 14px;
                }
            }

            .el-button:hover {
                color: var(--primary) !important;

                .el-icon-search {
                    color: var(--primary);
                }
            }

            .el-button:focus {
                color: var(--primary) !important;

                .el-icon-search {
                    color: var(--primary);
                }
            }

            .lista-pssc__barra-pesquisa__input {
                width: 100%;
                height: 100%;
                border: none;
                outline: none;
                border-radius: 5px;
                color: var(--primary);
            }
        }

        .lista-pssc__barra-pesquisa-filtro__filtro {
            height: 46px;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            width: fit-content;
        }

        .btn-filtro {
            height: 46px !important;
        }

        .pesquisa-inteligente__ul {
            list-style: none;
            padding: 16px 0;
            position: relative !important;
            z-index: 42;
            margin-top: 16px;
            border-radius: 5px;
            background-color: var(--white);
            box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);

            .pesquisa-inteligente__lista-vazia {
                color: #7C7C7C;
                padding-left: 41px;
            }

            .pesquisa-inteligente__lista {
                display: grid;
                grid-gap: 8px !important;

                .pesquisa-inteligente__car {
                    margin: 0 !important;

                    li {
                        padding-left: 18px;
                        margin-top: 5px;
                        cursor: pointer;
                    }

                    .pesquisa-inteligente__categoria {
                        font-weight: bold;

                        span {
                            padding: 0 16px;
                        }
                    }

                    .pesquisa-inteligente__item {
                        padding: 8px 0 7px 0;
                        margin-top: 0px !important;

                        span {
                            padding: 0 16px;
                        }
                    }

                    .pesquisa-inteligente__item:hover {
                        background-color: #DEF0B9;
                    }
                }
            }
        }
    }

    .lista-pssc__totalizadores {
        margin-bottom: 20px;

        .lista-pssc__totalizadores__cards {
            display: grid;
            gap: 15px;
            grid-template-columns: 1fr 1fr 1fr 1fr;

            .lista-pssc__totalizadores__cards__card {
                height: 70px;
                padding: 10px 16px;
                background: white;
                border-radius: 5px;
                display: grid;
                grid-template-columns: 70% 30%;
                align-items: center;
                justify-items: center;
                font-size: 14px;
                font-weight: 500;
            }
        }
    }

    .lista-pssc__lista {
        .selecao-tabela__container {
            margin: 8px 0 8px 0;

            .card-contagem-selecao {
                height: 40px;
                background-color: #DEF0B9;
                border-radius: 4px;
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 8px;

                .contagem-selecao {
                    display: flex;
                    height: fit-content;

                    .contador-selecao {
                        font-weight: 600;
                    }

                    .descricao-selecao {
                        font-weight: normal;
                    }
                }

                .acao-selecao {
                    height: fit-content;
                    font-weight: 500;
                    color: #4294EC;
                    cursor: pointer;
                }
            }
        }

        .lista-pssc__lista__tabela {
            height: calc(100vh - 433px);
            background-color: var(--white);
            border-radius: 5px;

            .el-table {
                border-radius: 5px;
                height: calc(100% - 40px);
                width: 100%;
            }

            .el-table th {
                font-weight: bold;
                font-size: 14px;
            }

            .tabela-btn {
                margin-top: 14px;
                display: flex;
                justify-content: flex-start;
                align-items: center;
            }

            .lista-pssc__lista__tabela__rodape {
                height: 40px;
                padding: 0 10px;
                background: var(--white);
                display: grid;
                justify-items: flex-start;
                align-items: center;
                grid-template-columns: 1fr 1fr;
                border-radius: 5px;

                .tabela-rodape--pagination {
                    width: 100%;
                    display: flex;
                    justify-content: flex-end;

                    .el-pager li.active {
                        color: var(--white);
                        font-weight: 900;
                        background: var(--primary);
                    }

                    .el-pager li {
                        padding: 0 4px;
                        background: var(--white);
                        vertical-align: top;
                        display: inline-block;
                        font-size: 13px !important;
                        min-width: 28px !important;
                        height: 28px !important;
                        line-height: 28px !important;
                        box-sizing: border-box;
                        text-align: center;
                        margin: 0;
                        border-radius: 2px;
                        color: var(--primary);
                    }

                    .el-pagination button {
                        height: 28px;
                    }
                }
            }

            .box-expande-listagem {
                display: flex;
                align-items: flex-start;
                justify-content: space-around;
                margin-top: 15px;
                margin-bottom: 15px;
                padding: 0 18px;

                .box-expande-listagem-box {
                    width: 33%;

                    .box-expande-listagem-box-texto {
                        font-weight: 600;
                        color: var(--primary);
                    }

                    .box-expande-listagem-box-value {
                        max-height: 75px;
                        overflow-y: auto;
                        font-weight: 400;
                        color: var(--primary);
                    }
                }
            }
        }
    }

    #titulo {
        margin-bottom: 10px;
        margin-top: 10px;
        color: var(--black);
        font-weight: 500;
        display: grid;
        justify-content: space-between;
        grid-template-columns: auto auto;
        height: fit-content;

        .btn-reprocessar {
            margin: 0 15px 0 0 !important;
        }

        .btn-enviar-trilha {
            height: fit-content;
            margin: 0 !important;
        }
    }

    #total {
        font-weight: 500;
        font-size: 16px;
        text-align: end;
        width: 100%;
    }

    .lyra-icon::before {
        content: '';
        width: 24px;
        height: 25px;
        display: inline-block;
        background-color: var(--primary);
    }
}

#titulo-filtro {
    color: var(--primary);
    font-weight: 500;
    font-size: 16px;
    line-height: 14px;
}

#titulo-filtro-link {
    color: #1989fa;
    font-weight: 500;
    text-decoration: underline;
    cursor: pointer;
    font-size: 16px;
    line-height: 14px;
}

.lista-pssc__barra-pesquisa-filtro__filtro-popover-collapse {
    .el-select {
        width: 100%;
    }

    .el-collapse-item__header {
        font-weight: 500;
    }

    .filtro-accordion {
        margin-top: 10px;
    }

    .el-checkbox,
    .el-radio {
        margin-right: 12px !important;
        min-width: 200px;
        line-height: 2;
    }

    .el-radio {
        color: var(--primary);
        font-weight: 500;
        line-height: 16px;
    }
}

.custom-header {
    .el-checkbox {
        display: flex;
        padding: 10px 15px;
        align-items: center;
        margin-bottom: 0 !important;
        border-bottom: 1px solid rgba(102, 102, 102, 0.18);
    }

    .is-checked {
        background-color: #DEF0B9 !important;
    }

    .el-checkbox:hover {
        background-color: #DEF0B9 !important;
    }
}

.el-select-dropdown__item.hover {
    background: white !important;
}

.el-select-dropdown__item:hover {
    background: #DEF0B9 !important;
}

.el-select-dropdown__item.selected {
    background-color: #DEF0B9 !important;
}

.el-tag.el-tag--info {
    background-color: #EBF4EB !important;
    border-color: #EBF4EB !important;
    color: #359138 !important;
    max-width: 100px !important;
    max-height: 40px !important;

    .el-tag__close {
        color: white !important;
        background: #359138 !important;
    }
}

.el-tooltip.el-tag.el-tag--primary.el-tag--small {
    width: fit-content;
}

.base-button-container {
    display: flex !important;
    gap: 20px;
}

.el-statistic .con {
    justify-content: flex-end !important;
}

.lista-scroll {
    max-height: 300px;
    overflow-y: auto;
    flex-direction: column;
    padding: 5px 10px;

    /* width */
    &::-webkit-scrollbar {
        width: 10px;
        height: 10px;
    }

    /* Track */
    &::-webkit-scrollbar-track {
        border-radius: 10px;
        background: var(--white);
    }

    /* Handle */
    &::-webkit-scrollbar-thumb {
        background: var(--text-disabled);
        border-radius: 10px;
        border: 3px solid var(--white);
    }

    /* Handle on hover */
    &::-webkit-scrollbar-thumb:hover {
        background: #b5b5b5;
    }
}

.el-checkbox.area__checkbox__filtro__dashboard {
    min-width: 23.5% !important;
    margin-right: 8px !important;

    .el-checkbox__label {
        font-size: 13px !important;
    }
}

.table-row_selected {
    background-color: #F4FAE8 !important;
}

.el-tooltip__popper.is-light{
    border: 1px solid #80a09e !important;
}
.etapa-processamento-label {
    font-size: 13px;
    padding: 7px 0 5px 5px;
}
.status-processamento-cinza {
    font-size: 24px;
    color: lightgray;
}
.status-processamento-verde {
    font-size: 24px;
    color: #43A349;
}
.status-processamento-amarelo {
    font-size: 24px;
    color: #EDAB1D;
}
.status-processamento-vermelho {
    font-size: 24px;
    color: #dc362e;
}
</style>
